import Modal from "../../Modal";

export const LoginErrorDialog = ({ open, onClose, error }) => {
    return (
        <Modal open={open} onExit={onClose}>
            <div className="p-4">
              <div className={"flex flex-row items-center gap-2"}>
                  {error}
              </div>
            </div>
        </Modal>
    );
}